export enum LegalFormalityAccountsApprovalEnum {
  initialized = 'initialized',
  notApplicable = 'not_applicable',
  collectScopeToDo = 'collect_scope_to_do',
  collectAwaitingBalanceSheetClosure = 'collect_awaiting_balance_sheet_closure',
  collectAssignmentToDo = 'collect_assignment_to_do',
  pvDocumentToGenerate = 'pv_document_to_generate',
  pvMailToSend = 'pv_mail_to_send',
  pvSignatureToSend = 'pv_signature_to_send',
  pvAwaitingSignature = 'pv_awaiting_signature',
  pvSignatureRefusal = 'pv_signature_refusal',
  depositToDo = 'deposit_to_do',
  depositToSign = 'deposit_to_sign',
  depositToPay = 'deposit_to_pay',
  depositAwaitingValidation = 'deposit_awaiting_validation',
  depositToRegularize = 'deposit_to_regularize',
  depositRejected = 'deposit_rejected',
  depositError = 'deposit_error',
  dossierToClose = 'dossier_to_close',
  pvDocumentToCheck = 'pv_document_to_check',
  completed = 'completed'
}
